const USER_APP_UUID_KEY = 'externo_user_app_uuid';

export const getOrCreateUserAppUuid = (): string => {
  let id = localStorage.getItem(USER_APP_UUID_KEY);
  if (!id) {
    id = crypto.randomUUID();
    localStorage.setItem(USER_APP_UUID_KEY, id);
  }
  return id;
};
